export default __webpack_public_path__ + "static/media/de.63b984c5.jpg";